import { Pipe, PipeTransform } from '@angular/core';
import { Mentorship, MentorshipType } from '@app/mentoring/mentoring-api.model';
import { MentoringHelperService } from '@app/mentoring/services/mentoring-helper.service';
import { MentorshipTypeEnum } from '../mentoring.enums';

@Pipe({
  name: 'mentoringBadge',
  pure: false,
})
export class MentoringBadgePipe implements PipeTransform {
  public constructor(private mentoringHelperService: MentoringHelperService) {}
  public transform(
    mentorship: Mentorship,
    type: MentorshipType = MentorshipTypeEnum.Mentee
  ) {
    return this.mentoringHelperService.getMentorshipStatus(
      mentorship.mentorshipStatusName,
      type
    );
  }
}
